import { enqueueSnackbar } from 'notistack'

export const showErrorSnackbar = (text: string) => {
  enqueueSnackbar(text, { variant: 'error' })
}

export const showSuccessSnacbar = (text: string) => {
  enqueueSnackbar(text, { variant: 'success' })
}